// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".top-section .section-header[data-v-4f21cd58]{font-size:17px;font-weight:700}.top-section__header[data-v-4f21cd58]{color:var(--primary-accessible,var(--primary))}.top-section .section-header[data-v-4f21cd58]:last-child,.top-section .section-text[data-v-4f21cd58]:last-child{margin-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
